import React, { useEffect, useState, useRef } from 'react'
import { Link, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import DataTable, { TableStyles } from 'react-data-table-component';
import { Button } from '@app/components';
import { useSelector } from 'react-redux';
import { getSettingPatternWithPagination } from '@app/services/settingPattern';
import ViewPatternDetailsModal from './ViewPatternDetailsModal';
import Select from "react-select";
import { getAllActiveFranchise } from '@app/services/franchise';
import { encodeId } from '@app/helpers/base64url';

const ListSettingPattern = () => {

    const [searchParams, setSearchParams] = useSearchParams()
    const [patterns, setPatterns] = useState([]);
    const [franchises, setFranchises] = useState([]);
    const [isLoading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(searchParams.get('perPage') ?? 10);
    const [currentPage, setCurrentPage] = useState(searchParams.get('page') ?? 1);
    const selectRef = useRef(null);
    const statuses = [{value:'active', label:'Active'}, {value:'inactive', label:'Inactive'}]
    // const selectRef = useRef(null);
    const [patternId, setPatternId] = useState(0);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const canAccess = useSelector((state: any) => state.auth.permissions['setting-pattern']);
    const role = useSelector((state: any) => state.auth.selectedRole.slug);

    const customStyle: TableStyles = {
        head: {
            style: {
                color: "#5E5873",
                fontSize: "13px",
                fontWeight: 900
            },
        },
        headCells: {
            style: {
                borderColor: "#E9ECEF",
                textTransform: "uppercase",
                letterSpacing: "1px",
            },
        },
        headRow: {
            style: {
                backgroundColor: "#F7F7F8",
                minHeight: "44px",
                fontWeight: 500,
            },
        },
    };
      
    useEffect(() => {
        getSettingPatternData();
    },[searchParams]);

     useEffect(() => {
        getAllActiveFranchiseData();
    },[]);

    const getAllActiveFranchiseData = async () => {
        try {
            const resp = await getAllActiveFranchise();
            if (resp?.success === true) {
                setFranchises([{id: 0, name: 'FCL Default'}, ...resp?.collections]);
                // setFranchises(resp?.collections);
            } else {
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            toast.error(error?.message || 'Internal server error');
        }
    };
    const getSettingPatternData = async () => {
        try {
            setLoading(true);
            const resp = await getSettingPatternWithPagination(searchParams);
            if (resp.success === true) {
                setLoading(false);
                setPatterns(resp?.collections?.data);
                setTotalRows(resp?.collections?.pagination?.total);
            } else {
                setLoading(false);
                toast.error(resp?.errors[0]?.msg);
            }
        } catch (error: any) {
            setLoading(false);
            toast.error(error?.message || 'Internal server error');
        }
    };

    const columns = [
        {
            name: 'Franchise',
            selector: (row: { franchise_name: string; }) => row.franchise_name ?? '---',
            cell: (row: { franchise_name: string; franchise_id: number; }) => (
                row.franchise_id === 0 ? <b>FCL Default</b> : row.franchise_name ?? '---'
            ),
            sortable: true,
            sortField: 'franchise_name',
        },
        {
            name: 'Pattern Name',
            selector: (row: { name: string; }) => row.name ?? '---',
            sortable: true,
            sortField: 'name',
        },
        {
            name: 'Streams Per Week',
            selector: (row: { modules_per_week: string; }) => row.modules_per_week,
            sortable: true,
            sortField: 'modules_per_week',
        },
        {
            name: 'Status',
            selector: (row: { status: string; }) => row.status,
            cell: (row: { status: string; }) => (
                row.status === 'active' ? <span className="badge bg-success">Active</span> : <span className="capitalize badge bg-danger">{row.status}</span>
            ),
            sortable: true,
            sortField: 'status',
        },
        {  
            name: 'Action',
            cell: (row: { id: number; franchise_id: number }) => (
              <>
                { canAccess?.view &&
                    <a href='#' onClick={ (e) => { handleViewPatternModal(e, row.id)} }>
                        <i className="fas fa-eye mr-2" title="View Pattern Details"></i>
                    </a>
                }
                { ((canAccess?.edit && row.franchise_id == 0 && (role === 'admin' || role === 'super-admin')) || (row.franchise_id > 0 && canAccess?.edit)) &&
                    <Link
                        to={`/setting-patterns/edit/${encodeId(row.id)}`}
                        role="button"
                        state={{ id: row.id }}
                        title="Edit Pattern Details"
                    >
                        <i className="fas fa-pen mr-2" />
                    </Link>
                }
                { canAccess?.copy &&
                    <Link
                        to={`/setting-patterns/copy/${encodeId(row.id)}`}
                        role="button"
                        state={{ id: row.id }}
                        title="Copy Pattern"
                    >
                        <i className="fas fa-copy mr-2" />
                    </Link>
                }
              </>
            ),
            omit: !(canAccess?.view || canAccess?.edit || canAccess?.copy)
        },
    ];

    const handleViewPatternModal = (e, id) => {
        e.preventDefault();
        handleShow();
        setPatternId(id);
    }

    const handlePageChange = page => {
        searchParams.set('page', page)
        setSearchParams(searchParams)
        
        setCurrentPage(page);
    };


    const handlePerRowsChange = async (newPerPage, page) => {
        searchParams.set('perPage', newPerPage)
        setSearchParams(searchParams)
        
        setPerPage(newPerPage);
    };

    const handleSort = async (column, sortDirection) => {
        searchParams.set('sortField', column.sortField)
        searchParams.set('sortDirection', sortDirection)
        setSearchParams(searchParams)
    };

    const handleResetFilter = async () => {
        selectRef.current.setValue('');
        searchParams.delete('franchiseId')
        searchParams.delete('name')
        searchParams.delete('status')
        setSearchParams(searchParams)  
    };

    const onChangeFranchise = (option) => {
        searchParams.set('franchiseId', option == null ? '' : option.id )
        setSearchParams(searchParams)
    };
    
    return (
        <div>
            <div>
                {/* Content Header (Page header) */}
                <section className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1>Setting Patterns</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb float-sm-right">
                                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                                    <li className="breadcrumb-item active">Setting Patterns</li>
                                </ol>
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}
                </section>
                {/* Main content */}
                <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div style={{ marginBottom: 10 }} className="row">
                                    
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        <h3 className="card-title">Setting Patterns</h3>
                                        <div className="col-lg-12 text-right">
                                            { canAccess?.create && 
                                                <Link className="btn btn-primary mr-2" to="/setting-patterns/add" > + Add New Pattern </Link> 
                                            }
                                        </div>
                                    </div>
                                    {/* /.card-header */}
                                    <div className="card-body">
                                        <div className="row mb-2">
                                            <div className="col-sm-3">
                                                <Select
                                                    ref={selectRef}
                                                    name="franchiseId"
                                                    placeholder="Search By Franchise"
                                                    options={franchises}
                                                    getOptionValue={(option)=>`${option['id']}`}
                                                    getOptionLabel={(option)=> option['name'] }
                                                    onChange={ (option) => {onChangeFranchise(option)}}
                                                    value={franchises.filter(function(option) {
                                                        if (searchParams.get('franchiseId') === "" || searchParams.get('franchiseId') === null) return false; // no default selection for empty or missing
                                                        return Number(option.id) === Number(searchParams.get('franchiseId'));
                                                    })}
                                                    isClearable={true}
                                                    formatOptionLabel={(option) => (
                                                        <div style={{ fontWeight: option.id == 0 ? 700 : '' }}>
                                                            {option.name}
                                                        </div>
                                                    )}
                                                />
                                            </div>
                                            <div className="col-sm-3">
                                                <input type="text" name='name' className="form-control" value={searchParams.get('name') ?? ''} onChange={(e) => { searchParams.set('name', e.target.value); setSearchParams(searchParams)}} placeholder="Search By Pattern Name" />
                                            </div>
                                            <div className="col-sm-3">
                                                <select
                                                    className="form-control"
                                                    name="status"
                                                    onChange={(e) => {  searchParams.set('status', e.target.value); setSearchParams(searchParams)}}
                                                    value={searchParams.get('status') ?? ''}
                                                >
                                                    <option value="">Search By Status</option>
                                                    {statuses.map((obj) => (
                                                        <option key={obj.value} value={obj.value}>
                                                            {obj.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div className='col-sm-2'>
                                                <Button type="submit" isLoading={isLoading} onClick={handleResetFilter} className="btn btn-warning">Reset Filter</Button>
                                            </div>
                                        </div>
                                        
                                        <DataTable
                                            columns={columns}
                                            data={patterns}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationDefaultPage={Number(currentPage)}
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            paginationPerPage={Number(perPage)}
                                            paginationRowsPerPageOptions={[5, 10, 20, 30, 50, 100]}
                                            progressPending={isLoading}
                                            sortServer
                                            onSort={handleSort}
                                            // paginationComponent
                                            // selectableRows
                                            customStyles={customStyle}
                                        />
                                    </div>
                                    {/* /.card-body */}
                                </div>
                            </div>
                            {/* /.col */}
                        </div>
                        {/* /.row */}
                    </div>
                    {/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>
            <ViewPatternDetailsModal
                show={show}
                handleClose={handleClose}
                id={patternId}
            />
        </div>
    )
};

export default ListSettingPattern;